exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addActiveObj_Dialog{margin-top:20vh!important}", ""]);

// exports
